import { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../Utility/constants";
import Footer from "../common/Footer";
import "./StudentPersonalDetails.css";
import TeacherHeader from "../common/TeacherHeader";
import { Table, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";

const ViewAttendance = () => {
  const [data, setData] = useState([]);
  const [attendanceDate, setAttendanceDate] = useState(""); // store selected date
  const [standardName, setStandardName] = useState(null);
  const [sectionName, setSectionName] = useState(null);
  const [loading, setLoading] = useState(false); // ✅ loading state

  const fetchData = async (date) => {
    setLoading(true);
    try {
      const teacherId = localStorage.getItem("userID");
      let url = `${baseUrl}/api/Attendance/GetStudentsWithAttendanceByTeacherId?TeacherId=${teacherId}`;
      if (date) {
        url += `&attendanceDate=${date}`; // pass date as query param
      }

      const response = await axios.get(url);
      if (response?.data) {
        const students = response.data;
        setStandardName(response.data[0]?.standardName || null);
        setSectionName(response.data[0]?.sectionName || null);
        setData(students);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      toast.error("Failed to load student details.");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TeacherHeader />
      <div className="container mt-5 mb-5">

        {/* Date picker and fetch button */}
        <div className="mb-3 align-items-center">
          <Row>
            <Col md={3}>
              <Form.Control
                type="date"
                value={attendanceDate}
                onChange={(e) => setAttendanceDate(e.target.value)}
                className="me-2"
              />
            </Col>
            <Col md={1}>
              <Button variant="primary" onClick={() => fetchData(attendanceDate)}>
                {/* {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    /> Loading...
                  </>
                ) : ( */}
                  Search
                {/* )} */}
              </Button>
            </Col>
            <Col md={4}>
              <Link
                className={`btn btn-secondary ${!data || data.length === 0 ? "disabled" : ""}`}
                to={`/attendance-report?std=${standardName}&div=${sectionName}&date=${attendanceDate}`}
                target="_blank"
                onClick={(e) => {
                  if (!data || data.length === 0) e.preventDefault(); // prevent navigation if disabled
                }}
              >
                Download Report
              </Link>
            </Col>
          </Row>
        </div>

        {loading ? (
          <div className="text-center my-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Table striped bordered hover responsive>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>Student Name</th>
                <th>Roll No</th>
                <th>GR No</th>
                <th>Attendance Status</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.studentId}>
                    <td>{index + 1}</td>
                    <td>{`${item.firstName} ${item.middleName || ""} ${item.lastName || ""}`.trim()}</td>
                    <td>{item.rollNo || ""}</td>
                    <td>{item.generalRegisterNo || ""}</td>
                    <td>{item.attendanceStatus}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default ViewAttendance;
